(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days && days > 0) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function pickEnvelopeSource(video) {
    var w = window.innerWidth;
    /* Mobile popup uses square so the invite tip isn't cropped (9:16 is for stories). */
    if (w <= 767) {
      return { src: video.getAttribute('data-src-square'), ratio: 'mobile' };
    }
    if (w <= 899) {
      return { src: video.getAttribute('data-src-square'), ratio: 'square' };
    }
    if (w <= 1199) {
      return { src: video.getAttribute('data-src-tablet'), ratio: 'tablet' };
    }
    return { src: video.getAttribute('data-src-desktop'), ratio: 'desktop' };
  }

  function initPopup(root) {
    if (!root || root.getAttribute('data-amc-bound') === '1') return;
    root.setAttribute('data-amc-bound', '1');

    var enabled = root.getAttribute('data-enabled') === 'true';
    var testMode = root.getAttribute('data-test-mode') === 'true';
    var seconds = parseInt(root.getAttribute('data-delay-seconds') || '2', 10);
    var days = parseInt(root.getAttribute('data-delay-days') || '2', 10);
    var cookieName = 'amc-envelope-popup-' + (root.getAttribute('data-section-id') || 'default');
    var timer = null;
    var teaser =
      document.querySelector('[data-amc-envelope-teaser]') ||
      (root.parentElement && root.parentElement.querySelector('[data-amc-envelope-teaser]'));
    var video = root.querySelector('[data-amc-envelope-video]');
    var envelope = root.querySelector('.amc-envelope-popup__envelope');
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!enabled && !testMode) return;
    if (window.location.pathname === '/challenge' || window.location.pathname === '/password') return;

    var dismissed = !testMode && days > 0 && !!getCookie(cookieName);

    var scrollLockY = 0;
    var scrollLocked = false;

    function lockScroll() {
      if (scrollLocked) return;
      scrollLocked = true;
      scrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      scrollLocked = false;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, scrollLockY);
    }

    function showTeaser(on) {
      if (!teaser) return;
      if (on) {
        teaser.hidden = false;
        teaser.classList.add('is-visible');
        document.documentElement.classList.add('amc-envelope-teaser-on');
      } else {
        teaser.hidden = true;
        teaser.classList.remove('is-visible');
        document.documentElement.classList.remove('amc-envelope-teaser-on');
      }
      window.dispatchEvent(new Event('resize'));
    }

    function syncVideoSource() {
      if (!video) return;
      var pick = pickEnvelopeSource(video);
      if (envelope) {
        if (pick.ratio === 'desktop') envelope.removeAttribute('data-amc-env-ratio');
        else envelope.setAttribute('data-amc-env-ratio', pick.ratio);
      }
      if (!pick.src) return;
      if (video.getAttribute('src') === pick.src) return;
      video.setAttribute('src', pick.src);
      video.load();
    }

    function playVideo() {
      if (!video) return;
      syncVideoSource();
      video.muted = true;
      video.defaultMuted = true;
      video.loop = !reduceMotion;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function pauseVideo() {
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }

    function open() {
      showTeaser(false);
      root.hidden = false;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
      playVideo();
    }

    function close(persist) {
      root.classList.remove('is-open');
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      unlockScroll();
      pauseVideo();
      if (persist !== false && days > 0) {
        setCookie(cookieName, '1', days);
        dismissed = true;
      }
      if (persist !== false) showTeaser(true);
    }

    root.querySelectorAll('[data-amc-envelope-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    var cta = root.querySelector('[data-amc-envelope-popup-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        close(true);
      });
    }

    if (teaser && teaser.getAttribute('data-amc-teaser-bound') !== '1') {
      teaser.setAttribute('data-amc-teaser-bound', '1');
      teaser.addEventListener('click', function () {
        open();
      });
    }

    function onEsc(e) {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      close(true);
    }
    document.addEventListener('keydown', onEsc);

    var resizeTimer = 0;
    window.addEventListener(
      'resize',
      function () {
        if (!root.classList.contains('is-open')) return;
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          resizeTimer = 0;
          playVideo();
        }, 150);
      },
      { passive: true }
    );

    if (dismissed) {
      showTeaser(true);
    } else {
      timer = window.setTimeout(open, Math.max(0, seconds) * 1000);
    }

    document.addEventListener(
      'shopify:section:unload',
      function () {
        if (timer) window.clearTimeout(timer);
        document.removeEventListener('keydown', onEsc);
        close(false);
        showTeaser(false);
      },
      { once: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-amc-envelope-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var node =
      e.target.querySelector('[data-amc-envelope-popup]') ||
      (e.target.matches && e.target.matches('[data-amc-envelope-popup]') ? e.target : null);
    if (node) initPopup(node);
  });
})();
